import React from "react";
import {
  WARM_UP_MANUAL_PIT_RULE,
  WARM_UP_SEQUENCE_ACCEPTANCE_NOTE,
  describeWarmUpInboundWorkflow,
  describeWarmUpSendOutcome,
  describeWarmUpTestMode,
} from "@/constants/warmUpSequenceDefaults";

export function WarmUpTestModeLine({ checking, testModeActive }) {
  return (
    <p className="text-[#9CA3AF] text-sm font-body" data-testid="warm-up-test-mode">
      {checking ? "Checking test mode." : describeWarmUpTestMode(testModeActive)}
    </p>
  );
}

export function WarmUpAcceptanceNote() {
  return (
    <p className="text-[#9CA3AF] text-sm font-body" data-testid="warm-up-acceptance-note">
      {WARM_UP_SEQUENCE_ACCEPTANCE_NOTE}
    </p>
  );
}

export function WarmUpInboundWorkflowLine({ checking, integrationPresent, locationSaved }) {
  return (
    <p className="text-[#F3F4F6] text-sm font-body" data-testid="warm-up-inbound-workflow">
      {checking
        ? "Checking incoming workflow handling."
        : describeWarmUpInboundWorkflow({ integrationPresent, locationSaved })}
    </p>
  );
}

export function WarmUpManualSendRule({ checking }) {
  return (
    <p className="text-[#9CA3AF] text-sm font-body" data-testid="warm-up-manual-sends">
      {checking
        ? "Checking the PIT connection for manual Warm Up and sending."
        : WARM_UP_MANUAL_PIT_RULE}
    </p>
  );
}

export function WarmUpSendOutcome({ status }) {
  if (!status) return null;
  return (
    <p className="text-[#F3F4F6] text-sm font-body" data-testid="warm-up-send-outcome">
      {describeWarmUpSendOutcome(status)}
    </p>
  );
}
